import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withFetch } from '@angular/common/http';


export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    // provideClientHydration(withEventReplay()), 
    provideHttpClient(withFetch())/*,
    provideAppInitializer(() => {
      const dataManagerConfig = inject(PlatformConfig);
      return firstValueFrom(dataManagerConfig.loadAppConfig2());
    })*/
    /*,
    {
      provide: APP_INITIALIZER,//TODO: have to check this thing, @deprecated — from v19.0.0, use provideAppInitializer instead
      multi: true,
      deps: [PlatformConfig],
      useFactory: (dataManagerConfig: PlatformConfig) => {
        return () => {
          return dataManagerConfig.loadAppConfig();
        };
      }
    }*/
  ]
};
